var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bto-sb-widget bto-sb-widget-category-nav bto-sb-widget-outrights-tabs"},[_c('div',{staticClass:"bto-sb-widget-content"},[_c('ul',_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.id,class:{
          'bto-sb-category-nav-active': _vm.value === tab.id,
          'bto-sb-category-nav-flag': tab.class !== undefined,
        }},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.selectTab(tab.id)}}},[_vm._v(" "+_vm._s(tab.tournamentName)+" ")])])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }